import { useEffect } from 'react';

import useOrgUnitData from '../../../state/orgUnit/UseOrgUnitData';

const useOrgUnitTreeView = (organizationId, isActive) => {
  const { orgUnitState, getOrgUnits, getOrgUnitsByOrganizationId } = useOrgUnitData();

  useEffect(() => {
    if (organizationId > 0) {
      getOrgUnitsByOrganizationId(organizationId);
    } else {
      getOrgUnits(isActive);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [organizationId, isActive]);

  return {
    orgUnitState
  };
};

export default useOrgUnitTreeView;